import { Box, Flex, Link, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../../components/InputCmp'
import { ModalPoliticaPrivacidade } from '../../../../../components/ModalPoliticaPrivacidade'
import { MascararCPF, ValidaCPF } from '../../../../../Utils/Helper'

interface iProps {
  cpf: string
  erro: string
  isLoading: boolean
  onChange: (cpf: string) => void
  onSubmit: () => void
}

export const FormularioCpf: React.FC<iProps> = ({ cpf, erro, isLoading, onChange, onSubmit }) => {
  const [IsAccepted, setIsAccepted] = useState(false)
  const [ModalPrivacidadeIsOpen, setModalPrivacidadeIsOpen] = useState(false)

  const cpfValido = ValidaCPF(cpf)
  const impedimento = !cpfValido
    ? 'CPF inválido'
    : (!IsAccepted ? 'Você precisa aceitar os termos e política de privacidade' : '')

  function Enviar(): void {
    if (impedimento !== '' || isLoading) return
    onSubmit()
  }

  return (
    <Flex justifyContent={'center'} w={'full'}>
      <ModalPoliticaPrivacidade
        isOpen={ModalPrivacidadeIsOpen}
        onClose={() => setModalPrivacidadeIsOpen(false)}
      />

      <Flex
        flexDir={'column'}
        w={'full'}
        maxW={'27.5rem'}
        bg={'var(--c1)'}
        borderRadius={'.25rem'}
        boxShadow={'var(--SombraBackground)'}
        padding={['1.5rem 1.25rem', '2rem 2.125rem 2.125rem']}
      >
        <h3>Acessar minhas pesquisas</h3>
        <Text fontSize={'.875rem'} color={'var(--Gray3)'} mt={'.25rem'} mb={'1.5rem'}>
          Informe o CPF cadastrado na sua empresa.
        </Text>

        {/* fontSize 16px evita o zoom automatico do Safari no iOS ao focar o campo */}
        <Box w={'100%'} sx={{ '@media(max-width: 480px)': { input: { height: '2.75rem' } } }}>
          <InputCmp
            label='CPF'
            placeholder='000.000.000-00'
            inputMode='numeric'
            autoComplete='off'
            maxLength={14}
            fontSize={'16px'}
            value={cpf}
            error={erro !== ''}
            errorMessage={erro}
            OnChange={(e) => onChange(MascararCPF(e))}
            onKeyDown={(e) => {
              if (e.key === 'Enter') Enviar()
            }}
          />
        </Box>

        <Text mt={'1.5rem'} fontSize={'.875rem'} lineHeight={'1.25rem'} color={'var(--Gray2)'}>
          Para iniciar o preenchimento da pesquisa, clique no botão abaixo. Ao clicar, você estará concordando com nossa política de privacidade, disponível nesse link:&nbsp;
          <Link
            href='https://sah.arquiteturahumana.com.br/Privacidade'
            isExternal
            fontWeight={'bold'}
            textDecoration={'underline'}
          >Política de privacidade.</Link>
        </Text>

        <Flex
          alignItems={'center'}
          mt={'.75rem'}
          sx={{ label: { paddingTop: '.5rem', paddingBottom: '.5rem' } }}
        >
          <CheckboxCmp
            fontSize='.875rem'
            isChecked={IsAccepted}
            OnChange={(e) => setIsAccepted(e)}
          >Aceito os termos e política de privacidade</CheckboxCmp>
        </Flex>

        <Flex mt={'1.25rem'}>
          <ElementoTooltipCmp width={'100%'} label={impedimento} bg={'var(--Red)'}>
            <ButtonCmp
              VarColor='Green2'
              w={'100%'}
              h={['2.75rem', '2.4rem']}
              fontSize={'16px'}
              isLoading={isLoading}
              isDisabled={impedimento !== ''}
              onClick={Enviar}
            >Acessar pesquisas</ButtonCmp>
          </ElementoTooltipCmp>
        </Flex>

        <Text
          mt={'.5rem'}
          fontSize={'.813rem'}
          fontWeight={'700'}
          color={'var(--Gray3)'}
          textAlign={'center'}
          _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => setModalPrivacidadeIsOpen(true)}
        >Você precisa aceitar os termos e política de privacidade para continuar.</Text>

        <Flex mt={'1.375rem'} pt={'1.125rem'} borderTop={'1px solid var(--c3)'}>
          <Text fontSize={'.75rem'} color={'var(--Gray4)'} lineHeight={'1.125rem'}>
            Seu CPF é usado apenas para identificar suas avaliações.
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
